import { useEffect, useState } from 'react';
import { getContent } from '../../services/content';
import { Link, useParams } from 'react-router-dom';
import VideoIframe from '../video-iframe/VideoIframe';
import { IVideoList } from '../../interfaces/IVideoList';
import './SingleVideo.scss';

function SingleVideo() {
  const [content, setContent] = useState<IVideoList>();
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);

    getContent().then((items) => {
      let d = items['video-list'].filter(
        (el: IVideoList) => el['video_id'] == id
      );

      setContent(d[0]);

      // @ts-ignore;
    });
  }, [id]);

  if (!content) {
    return <div className="single-loading">Loading…</div>;
  }

  return (
    <div className="single-video">
      <Link className="back-link" to={{pathname: `/`}}>
        <svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
        Back to videos
      </Link>

      <div className="single-grid">
        <div className="player">
          <VideoIframe embed={content['embed']} />
        </div>

        <aside className="single-side">
          <h1 className="single-title">{content['title']}</h1>
          <div className="single-meta">
            <span>{content['views']}</span>
            {content['ago'] && <><span className="dot"/><span>{content['ago']}</span></>}
          </div>
          <div
            className="single-desc"
            dangerouslySetInnerHTML={{ __html: content['description'] }}
          />
        </aside>
      </div>
    </div>
  );
}

export default SingleVideo;
